import { healthcare } from "../routes"

export const healthCompanies = `${healthcare}/result/:id`
export const healthForm = `${healthcare}/form`
